module.exports = __webpack_public_path__ + "assets/icon-newtab-light.png";